"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setClearableTimeout = void 0;
const setClearableTimeout = (fn, timeout, code, map) => {
    map[code] = setTimeout(() => {
        fn();
        delete map[code];
    }, timeout);
};
exports.setClearableTimeout = setClearableTimeout;
